/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import { UploadChangeParam, UploadFile } from 'antd/lib/upload';

export interface IFileUploadInstance {
    getFiles(): UploadFile[];
    clearFiles(): void;
}
interface IProps {
    onInstance?: (instance: IFileUploadInstance) => any;
}

export function ImportFileUpload(props: IProps) {
    const { onInstance } = props;
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [valueWrapper] = useState<{ value?: UploadFile[], setFileList?: any }>({});
    valueWrapper.value = fileList;
    valueWrapper.setFileList = setFileList;
    useEffect(() => {
        if (onInstance) {
            onInstance({ getFiles: () => valueWrapper.value || [], clearFiles: () => valueWrapper.setFileList([]) })
        }
    }, [onInstance]);

    function onChange(info: UploadChangeParam<UploadFile<any>>) {
        const { status } = info.file;
        if (status !== 'uploading') {
            setFileList([...info.fileList]);
        }
    }
    return (<Upload name="file" multiple={true} fileList={fileList} onChange={onChange} beforeUpload={() => false} listType="text">
        <p className="ant-upload-drag-icon" style={{ fontSize: "32px" }}>
            <InboxOutlined />
        </p>
        <p className="ant-upload-text">Click or drag file to this area to upload</p>
        <p className="ant-upload-hint">
            Support for a single or bulk upload.
        </p>
    </Upload>);
}
